export default "__VITE_ASSET__BE4tzS$o__"